import { h } from 'preact';
import Close from "utils/icon/close.svg";
import { useEffect, useState } from "preact/hooks";
import * as queries from "utils/storefront/queries";
import Storefront from "utils/storefront";
import BlogFiltersModal from "./blog-filters-modal";
import BlogFiltersFacets from "./blog-filters-facets";

const storefront = Storefront.getInstance();

const BlogFilters = ({
  tags,
  sort,
  selectedTags,
  sortValues,
  modalIsActive,
  onClose,
  onFilter,
  blogId,
  articleCounter,
  setArticleCounter
}) => {
  const [facets, setFacets] = useState([]);

  useEffect( () => {
    if (tags.length) {
      storefront.request({
        query: queries.getBlogFacets(tags),
        variables: {},
      }).then(response => {
        if (response.data) {

          let newEdgesArray;

          // the results from the graphQL query include all blog articles
          // this will filter out the articles that are not in the current blog that is being viewed
          // eslint-disable-next-line no-restricted-syntax, guard-for-in
          for (const property in response.data) {
            newEdgesArray = response.data[property].edges.filter(edge => edge.node.blog.id.split('Blog/')[1] === blogId.toString());
            response.data[property].edges = [];
            response.data[property].edges = newEdgesArray;
          }

          setFacets(Object.keys(response.data).map((key, index) =>
              (
                {
                  amount: response.data[key].edges.length,
                  tag: tags[index],
                  ids: response.data[key].edges.map(item => item.node.id)
                }
              )
            )
          );
        }
      });
    }
  }, [tags]);

  const handleClear = () => {
    onFilter({
      tags: []
    })

    setArticleCounter({
      ...articleCounter,
      displayTotalArticleCount: true,
      count: articleCounter.totalArticleCount
    })
  }

  return (
    <div>
      {modalIsActive && (
        <BlogFiltersModal
          onClose={onClose}
        >
            <BlogFiltersFacets
              items={tags}
              values={selectedTags}
              facets={facets}
              onClose={onClose}
              sortBy={sort}
              sortValues={sortValues}
              onFilter={onFilter}
              articleCounter={articleCounter}
              setArticleCounter={setArticleCounter}
            />
        </BlogFiltersModal>
      )}
      <div className="hidden lg:flex items-center justify-between p-5 lg:p-0 lg:mb-7">
        <p className="text-headline-tag">{window.TMW.Strings.filters.label} {!!selectedTags.length && `(${selectedTags.length})`}</p>
        <button
          disabled={!selectedTags.length}
          onClick={handleClear}
          className="hidden underline hover:no-underline lg:block"
        >
          {window.TMW.Strings.filters.clear}
        </button>
      </div>
      <div className="divide-y divide-grey-4 lg:border-t  border-grey-4">
        {!!selectedTags.length && (
          <div className="pt-6 pb-3">
            <div className="overflow-x-auto lg:overflow-visible pb-3">
              <ul className="flex flex-wrap gap-2.5 w-max lg:w-full ">
                {selectedTags.map(tag => (
                  <li
                    key={tag}
                    className="w-max flex items-center justify-center gap-2.5 py-2.5 px-3 border rounded-sm"
                  >
                    <p className="text-body-2 text-black">{tag}</p>
                    <button
                      onClick={() =>
                        onFilter({tags: [
                          ...selectedTags.filter(i => i !== tag)
                        ]})
                      }
                      type="button"
                      aria-label="delete selected item"
                      title="delete selected item" tabIndex="0"
                    >
                      <Close className="scale-75"/>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        <div className="hidden lg:block">
          <BlogFiltersFacets
            inline
            items={tags}
            values={selectedTags}
            facets={facets}
            onFilter={onFilter}
            articleCounter={articleCounter}
            setArticleCounter={setArticleCounter}
          />
        </div>
      </div>
    </div>
  )
};

export default BlogFilters;
